import React, {Component} from "react";

import {buildOutOfGymsessionURL} from "../../../services/game-session/game-session-service";

import "./out-of-gym-player-card.css";

import Constants from '../../../constants/constants';

class OutOfGymPlayerCard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            playerSelected: false
        };
    }

    handlePlayClick() {
        const {player, token, startPlayerSession} = this.props;
        startPlayerSession();
        this.setState({playerSelected: true});
        window.location = buildOutOfGymsessionURL(player.id, token, Constants.getPlayContentUrl())
    }

    render() {
        const {playerSelected} = this.state;
        const {player, startingPlayerSession} = this.props;


        return (
            <tr className='out_of_gym_player_row'>
                <td className='out_of_gym_player_card_text'>{player.name}</td>                
                <td className='out_of_gym_player_card_text'>{player.owner.name}</td>                
                <td>
                    {!startingPlayerSession && <button className='out_of_gym_play_button' onClick={this.handlePlayClick.bind(this)}><i className='fa fa-play out_of_gym_play_button_icon' ></i>Play</button>}
                    {playerSelected && <div>Loading <i className='fa fa-spinner fa-spin'></i></div>}
                </td>
            </tr>
        );
    }
}

export default OutOfGymPlayerCard;


// WEBPACK FOOTER //
// ./src/components/components/out-of-gym-player-card/out-of-gym-player-card.js